import { call, cps, put } from "redux-saga/effects";
import { callAPI } from "./apiSaga";
import { push } from "connected-react-router";
import jwt_decode from "jwt-decode";
import { ConvertTypes } from "../../Utilities/converterparamscnf.js";
import { ConvertTypesOut } from "../../Utilities/converterparamscnf.js";
import {
  login,
  logout,
  SetLocale,
  setEnableDownload,
  setEnableCRUD,
  setAuthNoAccess,
  setAuthRequiredPermissions,
  setOnlyOneFileAtTime,
  setCreatedDefaultConverters,
  getConvertersDone,
} from "../actions/actions";
import { initialLanguage } from "../../languages/languages.js";

const REACT_APP_FETCH_SUBSCRIPTION =
  window.process !== undefined
    ? window.process.env.REACT_APP_FETCH_SUBSCRIPTION
    : process.env.REACT_APP_FETCH_SUBSCRIPTION;

//these variables depends of the logical ops. of next readed permission
let enablApplication = false;
let enabledownload = false;
let onlyOneFileAtTime = false;
let createdDefaultConverters = false;

//readed permission variables
let permissionFlexOffer = false;
let subscriptionFlexOffer = false;
let permissionQuickNext = false;
let subscriptionQuickNext = false;
let permissionPatternConvert = false;
let subscriptionPatternConvertStandAlone = false;
let subscriptionMTO_FashionOnDemmand = false;
let subscriptionMTO_FurnitureOnDemmand = false;
let subscriptionMTC_FashionOnDemmand = false;
let subscriptionMTC_FurnitureOnDemmand = false;
let subscriptionOD_FashionOnDemmand = false;
let subscriptionOD_FurnitureOnDemmand = false;
let subscriptionMTM_FashionOnDemmand = false;
let subscriptionMTM_FurnitureOnDemmand = false;
let subscriptionInteractivePlus = false;
let subscriptionQuickOffer = false;

let subscriptionPCONV_LSM = false;
let subscriptionPCONV_SUBSCRIPTIONS = false;

let subscriptionValiaFashion = false;
let subscriptionValiaFurniture = false;

let subscriptionVALIA_PACK2_FA = false;
let subscriptionVALIA_PACK2_FU = false;
let subscriptionVALIA_PACK3_FA = false;
let subscriptionVALIA_PACK4_FA = false;
let subscriptionVALIA_PACK4_FU = false;
let subscriptionVALIA_PACK5_FU = false;

let subscriptionVALIA_MP2_AU = false;

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
const tryEvaluate = (defaultValue, fn, args = []) => {
  try {
    return fn(...args);
  } catch (e) {
    return defaultValue;
  }
};

function decodeToken(token) {
  const {
    email,
    nickname,
    picture,
    "https://metadata.lectra.com/user_metadata": { given_name: firstName, family_name: lastName, locale },
    "https://metadata.lectra.com/app_metadata": {
      company: { id: tenantId },
      company: { subscriptions: companySubscriptions },
    },
    "https://metadata.lectra.com/app_metadata": { permissions },
  } = jwt_decode(token);
  return {
    lastName,
    firstName,
    email,
    locale,
    nickname,
    picture,
    tenantId,
    permissions,
    companySubscriptions,
  };
}

//Considering the subscription and the grace period
function companySubscriptionsIsActive(companySubscriptions, subscription) {
  let currentDate = new Date();

  let endDate = companySubscriptions[subscription].endDate;
  let graceDate = companySubscriptions[subscription].graceDate;

  let currentDatems = currentDate.getTime();
  var endDatems = new Date(endDate).getTime();
  var graceDatems = 0;
  if (graceDate !== undefined) graceDatems = new Date(graceDate).getTime();

  if (currentDatems <= Math.max(endDatems, graceDatems)) return true;
  else return false;
}

//Considering only endDate
function SubscriptionsIsActive(subscriptionEndDate) {
  let currentDate = new Date();

  let endDate = subscriptionEndDate;
  let currentDatems = currentDate.getTime();
  var endDatems = new Date(endDate).getTime();

  if (currentDatems <= Math.max(endDatems)) return true;
  else return false;
}
export function* GetSubscriptions() {
  const url = REACT_APP_FETCH_SUBSCRIPTION + "/subscriptions";
  const { success, result } = yield call(callAPI, { url });
  //let subscription = result.toString();
  if (success) {
    /*
    let converters = result.toString();
    if (converters === "" || isJson(converters) === false)
      converters = '{"Converter":[]}';
    const { Converter } = JSON.parse(converters);*/

    let subscriptions = result;
    let i = 0;
    while (i < subscriptions.length) {
      let currentofferId = subscriptions[i].offerId;
      let currentendDate = subscriptions[i].endDate;
      //2nd. whith QuickNext subscription
      if (currentofferId === "C2" && SubscriptionsIsActive(currentendDate)) {
        subscriptionQuickNext = true;
      }
      //3nd. whith FlexOffer subscription
      if (currentofferId === "FLEX" && SubscriptionsIsActive(currentendDate)) {
        subscriptionFlexOffer = true;
      }
      //whith MTO_FashionOnDemmand subscription
      if (currentofferId === "MTO_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionMTO_FashionOnDemmand = true;
      }
      // whith MTO_FurnitureOnDemmand subscription
      // S-125214 Remove endDate/graceDate evaluation for Furni on demand offer
      if (currentofferId === "MTO_FU") {
        subscriptionMTO_FurnitureOnDemmand = true;
      }

      //whith MTC_FashionOnDemmand subscription
      if (currentofferId === "MTC_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionMTC_FashionOnDemmand = true;
      }
      // whith MTC_FurnitureOnDemmand subscription
      // S-125214 Remove endDate/graceDate evaluation for Furni on demand offer
      if (currentofferId === "MTC_FU") {
        subscriptionMTC_FurnitureOnDemmand = true;
      }
      //whith OD_FashionOnDemmand subscription
      if (currentofferId === "OD_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionOD_FashionOnDemmand = true;
      }
      // whith OD_FurnitureOnDemmand subscription
      // S-125214 Remove endDate/graceDate evaluation for Furni on demand offer
      if (currentofferId === "OD_FU") {
        subscriptionOD_FurnitureOnDemmand = true;
      }

      //whith MTM_FashionOnDemmand subscription
      if (currentofferId === "MTM_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionMTM_FashionOnDemmand = true;
      }
      // whith MTM_FurnitureOnDemmand subscription
      // S-125214 Remove endDate/graceDate evaluation for Furni on demand offer
      if (currentofferId === "MTM_FU") {
        subscriptionMTM_FurnitureOnDemmand = true;
      }
      // whith PCONV_STANDALONE subscription
      if (currentofferId === "PCONV_STANDALONE" && SubscriptionsIsActive(currentendDate)) {
        subscriptionPatternConvertStandAlone = true;
      }

      // whith PCONV_LSM subscription
      if (currentofferId === "PCONV_LSM" && SubscriptionsIsActive(currentendDate)) {
        subscriptionPatternConvertStandAlone = true;
      }
      // whith PCONV_SUBSCRIPTIONS subscription
      if (currentofferId === "PCONV_SUBSCRIPTIONS" && SubscriptionsIsActive(currentendDate)) {
        subscriptionPatternConvertStandAlone = true;
      }
      // whith QUICK_INTER_PLUS subscription
      if (currentofferId === "QUICK_INTER_PLUS" && SubscriptionsIsActive(currentendDate)) {
        subscriptionInteractivePlus = true;
      }
      // whith QUICK_OFFER subscription
      if (currentofferId === "QUICK_OFFER" && SubscriptionsIsActive(currentendDate)) {
        subscriptionQuickOffer = true;
      }
      // whith Valia Fashion subscription
      if (currentofferId === "PM_PLAN_PROD_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionValiaFashion = true;
      }
      // whith Valia Furniture subscription
      /*
      if (currentofferId === "PM_PLAN_PROD_FU" && SubscriptionsIsActive(currentendDate)) {
        subscriptionValiaFurniture = true;
      }
      */
      // whith Valia subscriptions
      if (currentofferId === "VALIA_PACK2_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_PACK2_FA = true;
      }
      if (currentofferId === "VALIA_PACK2_FU" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_PACK2_FU = true;
      }
      if (currentofferId === "VALIA_PACK3_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_PACK3_FA = true;
      }
      if (currentofferId === "VALIA_PACK4_FA" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_PACK4_FA = true;
      }
      if (currentofferId === "VALIA_PACK4_FU" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_PACK4_FU = true;
      }
      if (currentofferId === "VALIA_PACK5_FU" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_PACK5_FU = true;
      }
      if (currentofferId === "MP2_AU" && SubscriptionsIsActive(currentendDate)) {
        subscriptionVALIA_MP2_AU = true;
      }
      i++;
    }
  } else {
    // Error
    yield put(setAuthNoAccess(false));
    let sRequiredPermissions = "Error " + url;
    yield put(setAuthRequiredPermissions(sRequiredPermissions));
    //yield put(setAuthCurrentPermissions(sCurrentPermissions));
  }
}
export default function* authenticate(auth0, location) {
  yield put(setCreatedDefaultConverters(createdDefaultConverters));
  console.log("setCreatedDefaultConverters Ponemos a cero");

  if (window.location.pathname === "/authenticated") {
    const { accessToken, expiresIn } = yield cps([auth0, auth0.parseHash]);

    if (accessToken && expiresIn) {
      const params = new URLSearchParams(location.search);
      const sourceURLInBase64 = params.get("sourceURL");
      const sourceURL = tryEvaluate("/", () => atob(sourceURLInBase64));
      yield put(push(sourceURL));
    }
  } else {
    window.document.getElementById("root").style.display = "none";
  }

  yield put(setAuthNoAccess(false));

  try {
    const REACT_APP_AUTH0_AUDIENCE =
      window.process !== undefined ? window.process.env.REACT_APP_AUTH0_AUDIENCE : process.env.REACT_APP_AUTH0_AUDIENCE;

    const { accessToken, idToken, expiresIn } = yield cps([auth0, auth0.checkSession], {
      audience: REACT_APP_AUTH0_AUDIENCE,
    });
    if (accessToken && idToken && expiresIn) {
      const { email, picture, firstName, lastName, nickname, locale, tenantId, permissions, companySubscriptions } =
        yield call(decodeToken, idToken);
      if (email !== undefined) window.document.getElementById("root").style.display = "";

      yield put(
        login({
          accessToken,
          idToken,
          expiresAt: new Date(new Date().getTime() + expiresIn * 1000),
          picture,
          nickname,
          firstName,
          lastName,
          email,
          locale,
          tenantId,
          permissions,
        })
      );

      const currentLocale = initialLanguage;
      yield put(SetLocale(currentLocale));

      yield call(GetSubscriptions);

      permissionPatternConvert = true;
      //Evaluate....
      // 1.- verify access to the application
      if (
        permissionPatternConvert === true &&
        (subscriptionFlexOffer ||
          subscriptionQuickNext ||
          subscriptionMTO_FashionOnDemmand ||
          subscriptionMTO_FurnitureOnDemmand ||
          subscriptionMTC_FashionOnDemmand ||
          subscriptionMTC_FurnitureOnDemmand ||
          subscriptionMTM_FashionOnDemmand ||
          subscriptionMTM_FurnitureOnDemmand ||
          subscriptionOD_FashionOnDemmand ||
          subscriptionOD_FurnitureOnDemmand ||
          subscriptionPatternConvertStandAlone ||
          subscriptionInteractivePlus ||
          subscriptionQuickOffer ||
          subscriptionValiaFashion ||
          subscriptionValiaFurniture ||
          subscriptionVALIA_PACK2_FA ||
          subscriptionVALIA_PACK2_FU ||
          subscriptionVALIA_PACK3_FA ||
          subscriptionVALIA_PACK4_FA ||
          subscriptionVALIA_PACK4_FU ||
          subscriptionVALIA_PACK5_FU ||
          subscriptionVALIA_MP2_AU)
      ) {
        enablApplication = true;
        enablApplication = true;
      }

      // 2.- verify download
      if (
        (permissionPatternConvert === true &&
          (permissionFlexOffer ||
            subscriptionFlexOffer ||
            permissionQuickNext ||
            subscriptionQuickNext ||
            subscriptionMTO_FashionOnDemmand ||
            subscriptionMTO_FurnitureOnDemmand ||
            subscriptionMTC_FashionOnDemmand ||
            subscriptionMTC_FurnitureOnDemmand ||
            subscriptionMTM_FashionOnDemmand ||
            subscriptionMTM_FurnitureOnDemmand ||
            subscriptionOD_FashionOnDemmand ||
            subscriptionOD_FurnitureOnDemmand ||
            subscriptionPatternConvertStandAlone ||
            subscriptionInteractivePlus ||
            subscriptionQuickOffer)) ||
        subscriptionValiaFashion ||
        subscriptionValiaFurniture ||
        subscriptionVALIA_PACK2_FA ||
        subscriptionVALIA_PACK2_FU ||
        subscriptionVALIA_PACK3_FA ||
        subscriptionVALIA_PACK4_FA ||
        subscriptionVALIA_PACK4_FU ||
        subscriptionVALIA_PACK5_FU ||
        subscriptionVALIA_MP2_AU
      ) {
        enabledownload = true;
      }

      //We check the case where only PCONV_STANDALONE is enabled. In that case, only one file would be allowed to be converted at a time
      if (
        subscriptionPatternConvertStandAlone === true &&
        (permissionFlexOffer ||
          subscriptionFlexOffer ||
          permissionQuickNext ||
          subscriptionQuickNext ||
          subscriptionMTO_FashionOnDemmand ||
          subscriptionMTO_FurnitureOnDemmand ||
          subscriptionMTC_FashionOnDemmand ||
          subscriptionMTC_FurnitureOnDemmand ||
          subscriptionMTM_FashionOnDemmand ||
          subscriptionMTM_FurnitureOnDemmand ||
          subscriptionOD_FashionOnDemmand ||
          subscriptionOD_FurnitureOnDemmand ||
          subscriptionInteractivePlus ||
          subscriptionQuickOffer ||
          subscriptionValiaFashion ||
          subscriptionValiaFurniture ||
          subscriptionVALIA_PACK2_FA ||
          subscriptionVALIA_PACK2_FU ||
          subscriptionVALIA_PACK3_FA ||
          subscriptionVALIA_PACK4_FA ||
          subscriptionVALIA_PACK4_FU ||
          subscriptionVALIA_PACK5_FU ||
          subscriptionVALIA_MP2_AU) === false
      ) {
        onlyOneFileAtTime = true;
      }
      //alert("Configure ConvertTypes and ConvertTypesOut");

      if (subscriptionPatternConvertStandAlone) {
        if (ConvertTypes.indexOf("accumark") < 0) ConvertTypes.push("accumark");
        if (ConvertTypes.indexOf("aama_astm") < 0) ConvertTypes.push("aama_astm");
        if (ConvertTypesOut.indexOf("mdl_V7") < 0) ConvertTypesOut.push("mdl_V7");
      }
      if (subscriptionPCONV_LSM) {
        if (ConvertTypes.indexOf("accumark") < 0) ConvertTypes.push("accumark");
        if (ConvertTypes.indexOf("aama_astm") < 0) ConvertTypes.push("aama_astm");
        if (ConvertTypesOut.indexOf("mdl_V7") < 0) ConvertTypesOut.push("mdl_V7");
      }
      if (subscriptionPCONV_SUBSCRIPTIONS) {
        if (ConvertTypes.indexOf("accumark") < 0) ConvertTypes.push("accumark");
        if (ConvertTypes.indexOf("aama_astm") < 0) ConvertTypes.push("aama_astm");
        if (ConvertTypesOut.indexOf("mdl_V7") < 0) ConvertTypesOut.push("mdl_V7");
      }
      if (subscriptionQuickNext || subscriptionFlexOffer) {
        if (ConvertTypes.indexOf("accumark") < 0) ConvertTypes.push("accumark");
        if (ConvertTypes.indexOf("aama_astm") < 0) ConvertTypes.push("aama_astm");
        if (ConvertTypesOut.indexOf("mdl_V7") < 0) ConvertTypesOut.push("mdl_V7");
      }
      if (
        subscriptionMTO_FashionOnDemmand ||
        subscriptionMTO_FurnitureOnDemmand ||
        subscriptionMTC_FashionOnDemmand ||
        subscriptionMTC_FurnitureOnDemmand ||
        subscriptionOD_FashionOnDemmand ||
        subscriptionOD_FurnitureOnDemmand ||
        subscriptionMTM_FashionOnDemmand ||
        subscriptionMTM_FurnitureOnDemmand ||
        subscriptionInteractivePlus ||
        subscriptionQuickOffer ||
        subscriptionValiaFashion ||
        subscriptionValiaFurniture ||
        subscriptionVALIA_PACK2_FA ||
        subscriptionVALIA_PACK2_FU ||
        subscriptionVALIA_PACK3_FA ||
        subscriptionVALIA_PACK4_FA ||
        subscriptionVALIA_PACK4_FU ||
        subscriptionVALIA_PACK5_FU ||
        subscriptionVALIA_MP2_AU
      ) {
        if (ConvertTypes.indexOf("accumark") < 0) ConvertTypes.push("accumark");
        if (ConvertTypes.indexOf("aama_astm") < 0) ConvertTypes.push("aama_astm");
        if (ConvertTypesOut.indexOf("mdl_V7") < 0) ConvertTypesOut.push("mdl_V7");
      }

      yield put(setAuthNoAccess(false));
      if (enablApplication === false) {
        // if no permission for PCONV  > logout
        /*
        Shows information about:
        1.-Needed permissions
        permissionPatternConvert("PCONV") AND (subscriptionFlexOffer( "FLEX") || subscriptionQuickNext("C2"))
        2.-Current user permissions
         permissionPatternConvert("PCONV")
         */
        //alert("################### PRUEBA ############\nenablApplication === false");

        let sRequiredPermissions =
          "permission PatternConvert(PCONV) AND (subscription FlexOffer(FLEX) || subscription QuickNext(C2))";
        let sCurrentPermissions = "";
        if (permissionPatternConvert) sCurrentPermissions = sCurrentPermissions + " permission PatternConvert(PCONV) ";
        if (subscriptionFlexOffer) sCurrentPermissions = sCurrentPermissions + " subscription FlexOffer (FLEX) ";
        if (subscriptionQuickNext) sCurrentPermissions = sCurrentPermissions + " subscription QuickNext (C2)";
        yield put(setAuthNoAccess(true));
        //yield put(logout());

        // yield put(setAuthRequiredPermissions(sRequiredPermissions));
        // yield put(setAuthCurrentPermissions(sCurrentPermissions));
        // show a dialog box, and after a delay
        // estar seguro de que si se cierra la ventana, no se pueda dentro. Salir de la app.
        //window.document.getElementById("btLogout").click();

        //window.location.assign(this.getForbiddenPageUrl(this.props.locale, this.getEnvironmentFromProcessEnvOrProp()));
        //return;
      } else {
        yield put(setAuthNoAccess(false));
      }
      //onlyOneFileAtTime = true;
      yield put(setEnableDownload(enabledownload));
      yield put(setEnableCRUD(false));
      yield put(setOnlyOneFileAtTime(onlyOneFileAtTime));
    }
  } catch (exception) {
    yield call([auth0, auth0.authorize]);
  }
}
